import * as React from "react";
const SvgFasteningsAndGlue = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20.86 21.21",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("g", { "data-name": "Layer 2" }, /* @__PURE__ */ React.createElement("path", {
	d: "M19.88 1a3.45 3.45 0 0 0-4.76 0L10.6 5.47l.2.59a1.4 1.4 0 0 1-.33 1.4 1.36 1.36 0 0 1-1.4.32l-.59-.19a2.57 2.57 0 0 0 0 3.63L.29 19.5a1 1 0 0 0 0 1.41 1 1 0 0 0 1.42 0L10 12.65a2.58 2.58 0 0 0 3.27-.31l-.2-.58a1.39 1.39 0 0 1 .33-1.4 1.37 1.37 0 0 1 1.4-.33l.59.19 4.43-4.43A3.47 3.47 0 0 0 20.8 4a3.38 3.38 0 0 0-.92-3m-1.42 3.29L14.77 8A3.37 3.37 0 0 0 11 10.91L9.92 9.83a3.37 3.37 0 0 0 2.92-3.77l3.69-3.7a1.41 1.41 0 0 1 1.93 0 1.3 1.3 0 0 1 .4 1 1.33 1.33 0 0 1-.4.93",
	"data-name": "Layer 1",
	style: { fill: "currentColor" }
})));
export default SvgFasteningsAndGlue;
